import { create } from 'zustand';

export interface Level {
  id: number;
  label: string;
  timeRecord: number;
  videoRecord: any;
  isActive: boolean;
  isPassed: boolean;
  recordChunksLevel: any;
  setRecordChunksLevel: any;
}

interface Store {
  levels: Level[];
  setLevels: (levels: Level[]) => void;
  updateLevel: (levelId: number, videoRecord: any) => void;
  updateActiveStatus: (levelId: number, status: boolean) => void;
  updatePassedStatus: (levelId: number, status: boolean) => void;
  step: number;
  setStep: () => void;
  decrementStep: () => void;
  setRecordChunksLevel: (levelId: number, recordChunk: any) => void;
  blob: Blob | MediaSource | any;
  setBlob: (bl: Blob) => void;
  blobs: Blob | MediaSource | any;
  setBlobs: (bl: Blob) => void;
  isFinished: boolean;
  setIsFinished: () => void;
  videoDurationTotal: any;
  setVideoDurationTotal: (st: any) => void;
  deleteVideoById: (id: number) => void;
  resetStore: () => void;
}

export const useCandidateStore = create<Store>()((set) => ({
  videoDurationTotal: [],
  setVideoDurationTotal: (video) =>
    set((state: any) => ({
      videoDurationTotal: [...state.videoDurationTotal, video],
    })),
  deleteVideoById: (id) =>
    set((state) => ({
      videoDurationTotal: state.videoDurationTotal.filter(
        (video: any) => video.id !== id,
      ),
    })),
  levels: [],
  step: 1,
  blob: undefined,
  setBlob: (bl: Blob) =>
    set(() => ({
      blob: bl,
    })),
  blobs: undefined,
  setBlobs: (bl: Blob) =>
    set(() => ({
      blobs: bl,
    })),
  setStep: () => set((state) => ({ step: state.step + 1 })),
  decrementStep: () => set((state) => ({ step: state.step - 1 })),

  setLevels: (levels: Level[]) => set({ levels }),
  updatePassedStatus: (levelId: number, status: boolean) =>
    set((state) => ({
      levels: state.levels.map((level) =>
        level.id === levelId ? { ...level, isPassed: status } : level,
      ),
    })),
  updateActiveStatus: (levelId: number, status: boolean) =>
    set((state) => ({
      levels: state.levels.map((level) =>
        level.id === levelId ? { ...level, isActive: status } : level,
      ),
    })),
  updateLevel: (levelId: number, videoRecord: any) => {
    set((state) => ({
      levels: state.levels.map((level) =>
        level.id === levelId
          ? { ...level, videoRecord, isActive: true }
          : level,
      ),
    }));
  },
  isFinished: false,
  setIsFinished: () => {
    set(() => ({
      isFinished: true,
    }));
  },
  setRecordChunksLevel: (levelId: number, recordChunk: any) => {
    set((state) => ({
      levels: state.levels.map((level) =>
        level.id === levelId
          ? {
              ...level,
              recordChunksLevel: recordChunk,
            }
          : level,
      ),
    }));
  },
  resetStore: () => {
    set({
      videoDurationTotal: [],
      levels: [],
      step: 1,
      blob: undefined,
      blobs: undefined,
      isFinished: false,
    });
  },
}));
